// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".obutton[data-v-e902d42c]{border-radius:.4rem;flex:1 1 0%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
